import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useCommonTranslation } from 'c-translation';

const useStyles = makeStyles(theme => ({
    box: {
        backgroundColor: alpha(theme.palette.background.default, 0.5),
    },
}));

const LoadingSpinner = () => {
    const { box } = useStyles();
    const loadingLabel = useCommonTranslation('Component.LoadingSpinner.label');
    return (
        <Box
            className={box}
            zIndex={10}
            position="absolute"
            height="100%"
            width="100%"
            color="secondary.contrastText"
            bgcolor="background.default"
            textAlign="center"
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexDirection="column"
            fontSize="12rem"
        >
            <CircularProgress aria-label={loadingLabel} />
        </Box>
    );
};

export default LoadingSpinner;
